module.exports = __webpack_public_path__ + "img/manage-vehicle.0f0b45ff.svg";